/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import Media from 'react-media';
import { object } from 'prop-types';
import { connect } from 'react-redux';
import DesktopProfileAndPassword from './DesktopProfileAndPassword/DesktopProfileAndPassword';
import ChangeEmail from '../ChangeEmail/ChangeEmail';
import ChangePassword from '../ChangePassword/ChangePassword';
import CUSTOM_BREAKPOINTS from '../../../../helpers/customBreakpoints';
import { getBrand } from '../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';

class ProfileAndPassword extends Component {
    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    render() {
        const breakpointExpr = `(min-width: ${CUSTOM_BREAKPOINTS.tabLandscape}px)`;
        return (
            <Media query={breakpointExpr}>
                {(matches) => (
                    (this.props.brand.code === 'PLA' || matches) ? (
                        <DesktopProfileAndPassword />
                    ) : (
                        <div className="padding-bottom-2x">
                            <ChangeEmail />
                            <div className="padding-top-2x">
                                <ChangePassword noBackButton />
                            </div>
                        </div>
                    ))}
            </Media>
        );
    }
}

ProfileAndPassword.propTypes = {
    brand: object.isRequired,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

export default connect(mapStateToProps)(ProfileAndPassword);
